import { Link } from "react-router-dom";
import type { NewsItem } from "@/types/comic";
import { formatDate } from "@/utils/comic";

interface NewsCardProps {
  news: NewsItem;
  variant?: "list" | "grid";
}

export default function NewsCard({ news, variant = "list" }: NewsCardProps) {
  if (variant === "grid") {
    return (
      <Link
        to={`/news/${news.id}`}
        className="group flex flex-col rounded-lg overflow-hidden bg-background-50 border border-background-200 hover:border-primary-300 transition-colors"
      >
        <div className="w-full aspect-[16/9] overflow-hidden bg-background-100">
          <img
            src={news.cover}
            alt={news.title}
            title={`${news.title} - 蛙漫动漫资讯`}
            className="w-full h-full object-cover object-top group-hover:scale-[1.04] transition-transform duration-500"
          />
        </div>
        <div className="p-4 flex flex-col gap-2">
          <span className="self-start px-2 py-0.5 rounded-md text-[11px] font-label font-bold bg-accent-100 text-accent-900">
            {news.category}
          </span>
          <h3 className="text-base font-label font-bold text-foreground-950 line-clamp-2 group-hover:text-primary-600 transition-colors">
            {news.title}
          </h3>
          <p className="text-sm text-foreground-600 line-clamp-2">{news.summary}</p>
          <div className="flex items-center gap-3 text-xs text-foreground-500">
            <span className="flex items-center gap-1">
              <i className="ri-calendar-line"></i>
              {news.date}
            </span>
            <span className="flex items-center gap-1">
              <i className="ri-eye-line"></i>
              {news.views}
            </span>
          </div>
        </div>
      </Link>
    );
  }

  return (
    <Link
      to={`/news/${news.id}`}
      className="group flex gap-3 py-3 border-b border-background-100 last:border-b-0"
    >
      <div className="w-[92px] h-[62px] shrink-0 rounded-md overflow-hidden bg-background-100">
        <img
          src={news.cover}
          alt={news.title}
          title={`${news.title} - 蛙漫动漫资讯`}
          className="w-full h-full object-cover object-top group-hover:scale-[1.05] transition-transform duration-500"
        />
      </div>
      <div className="flex flex-col gap-1 min-w-0">
        <h3 className="text-sm font-label font-bold text-foreground-900 line-clamp-2 group-hover:text-primary-600 transition-colors">
          {news.title}
        </h3>
        <div className="flex items-center gap-2 text-xs text-foreground-500">
          <span className="px-1.5 py-0.5 rounded bg-secondary-100 text-secondary-900 font-label">
            {news.category}
          </span>
          <span>{formatDate(news.date)}</span>
        </div>
      </div>
    </Link>
  );
}